module.exports = __webpack_public_path__ + "img/TDBank.0d639537.svg";